/**
 * @module estrutura/ui/estruturalabelui
 */

import { Plugin } from 'ckeditor5/src/core';
import { ButtonView } from 'ckeditor5/src/ui';

/**
 * The estrutura label UI feature.
 *
 * It introduces the `'estruturalabel'` button.
 *
 * @extends {Plugin}
 */
export default class OpdocsUI extends Plugin {
	/**
	 * @inheritDoc
	 */
	static get pluginName() {
		return 'OpdocsUI';
	}

	/**
	 * @inheritDoc
	 */
	init() {
		const editor = this.editor;
		const opdocs = editor.config.get( 'opdocs' );
		if ( Array.isArray( opdocs ) ) {
			for ( const opdoc of opdocs ) {
				addButton( editor, opdoc );
			}
		} else if ( opdocs != null ) {
			addButton( editor, opdocs );
		}
	}
}

function addButton( editor, { name, command, label, keystroke, icon, isOn } ) {
	const btnLabel = ( label || name ).substr( 0, 1 ).toUpperCase();
	let keystrokeLbl = '';
	if ( keystroke ) {
		editor.keystrokes.set( keystroke, ( data, cancel ) => {
			command( editor );
			cancel()
		} );
		keystrokeLbl = ` (${ keystroke })`;
	}

	const btnTooltip = `${ label || name }${ keystrokeLbl }`;

	editor.ui.componentFactory.add( name, locale => {
		const view = new ButtonView( locale );

		view.set( {
			label: btnLabel,
			icon: icon,
			keystroke: keystroke,
			tooltip: btnTooltip,
			withText: !icon
		} );

		if ( isOn != null ) {
			view.set( 'isOn', isOn );
		}

		editor.listenTo( view, 'execute', () => {
			if ( isOn != null ) {
				view.set( 'isOn', !view.isOn );
			}
			return command( editor );
		} );

		return view;
	} );
}
